<template>
  <div class="home container">
    <div class="grid-container">
      <div class="grid-container--left">
        <img
          alt="Sample image boxgenerator"
          src="../assets/boxgenerator_sample1.jpg"
          class="responsive img-responsive"
        />
      </div>
      <div class="grid-container--right">
        <h1>Tuunix BoxGenerator</h1>

        <p>
          This is the Tuunix BoxGenerator App. <br />To use it you need to buy licence
          from ???
        </p>
        <p><strong>With this application you can:</strong></p>
        <ul class="features">
          <li>
            Get custom offer requests from customers by embedding this app into
            your website
          </li>
          <li>
            Generate hundreds of different size box images automatically from
            excel-file
          </li>
          <li>
            Make your box webshop beautiful by having all the box photos same
            style, color and scale/ratio
          </li>
          <li>
            Generate more images later to your new models and they still have
            the same style, color, lightning that matches the previous photos
          </li>
          <li>
            Save thousands of dollars by not needing to setup photo studio, hire
            photographer and professional photo-editor to make all the photos
            same style
          </li>
        </ul>
        <p>
          You can test this generator with limited capabilities <router-link to="/init/fff7ed81b69ca07c667a9e0dd3c4fd6a">here</router-link>
        </p>
        <p>
          Read more at <a href="https://www.tuunix.fi/boxgenerator/">???</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Home",
  components: {}
};
</script>

<style>


.container {
    max-width: 920px;
}

ul.features {
    counter-reset: index;
    padding: 0;
}

ul.features > li {
    /*
    counter-increment: index;
    display: flex;
    align-items: left;
    text-align: left;
    padding: 12px 0;
    box-sizing: border-box;
    */
    text-align: left;
    padding-left: 2.5rem;
    position: relative;
    list-style-type: none;
    margin-bottom: 0.5rem;
    font-size: 1.2rem;
}


    /* Element counter */

    /*
    ul.features > li::before {
    content: counters(index, ".", decimal-leading-zero);
    font-size: 1.5rem;
    text-align: right;
    font-weight: bold;
    min-width: 50px;
    padding-right: 12px;
    font-variant-numeric: tabular-nums;
    align-self: flex-start;
    background-image: linear-gradient(to bottom, aquamarine, orangered);
    background-attachment: fixed;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    }
    */

ul.features > li:before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: -2px;
    width: 5px;
    height: 11px;
    border-width: 0 2px 2px 0;
    border-style: solid;
    border-color: #00a8a8;
    transform-origin: bottom left;
    transform: rotate(45deg);
}


/* Element separation */
ul.features li + li {
    border-top: 1px dotted rgb(215, 207, 160);
    border-image: linear-gradient(to left, #dbcb94 80%, #fff 90%, #fff 100%); /* to top - at 50% transparent */
    border-image-slice: 1;
}
</style>
